import { useState } from "react";
import { createPrescription } from "../../api/prescriptionService";

export const useCreatePrescription = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createPrescription(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create prescription:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};